import dayjs, { type Dayjs } from 'dayjs';

const bases = {
  now: () => dayjs(),
  startOfDay: () => dayjs().startOf('day'),
} satisfies Record<string, () => Dayjs>;

// Own-key check: an inherited name like `toString` would otherwise resolve to a function
const isToken = (limit: string): limit is keyof typeof bases => Object.keys(bases).includes(limit);

const offsetPattern = /^(\w+)([+-])(\d+)([yMd])$/;

/**
 * Resolves a `min`/`max` bound on a date field: a token (`now`, `startOfDay`), a token with an
 * offset (`startOfDay-5y`, `now+30d`; units `y`, `M`, `d`) or a date.
 */
export function parseDateLimit(limit?: string): Dayjs | undefined {
  if (limit === undefined) return undefined;
  if (isToken(limit)) return bases[limit]();

  const [, base, sign, amount, unit] = offsetPattern.exec(limit) ?? [];
  if (base && isToken(base) && unit) {
    return bases[base]().add(Number(`${sign}${amount}`), unit as 'y' | 'M' | 'd');
  }

  return dayjs(limit);
}
